import React from 'react';
import PropTypes from 'prop-types';

const LogoImage = ({ src }) =>
  <img
    src={src}
    alt='Logo'
    style={{ display: 'block', maxWidth: '200px' }}
  />;

LogoImage.propTypes = {
  src: PropTypes.string.isRequired
};

export default LogoImage;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Logo/LogoImage.js